<template>
    <div>
        <!--LOGIN FORMS-->
            <div class="row justify-content-center">
                <div class="col-xs-12 col-sm-8 col-md-8 col-lg-6">                    
                    <div class="card mt-2">
                        <div class="card-header lead">Login</div>
                            <div class="card-body">
                                <div class="card-text">
                                    
                                    <input @input="$v.useremail.$touch()"  
                                            v-model="useremail"
                                            class="form-control mb-2" 
                                            placeholder="Enter email" 
                                            type="email">
                                                <small class="text-danger" v-if="!$v.useremail.email">* Please provide a valid email</small>
                                                <small class="text-danger" v-if="!$v.useremail.required">* The email address is required</small>                            
                                    <input @input="$v.userpassword.$touch()" 
                                            v-model="userpassword" 
                                            class="form-control mb-2" 
                                            placeholder="Enter password" 
                                            type="password">
                                                <small class="text-danger" v-if="!$v.userpassword.required">* Password is required</small>
                                        <hr>
                                    <button :disabled="$v.$invalid" class="form-control btn btn-outline-secondary pt-4 pb-5" @click="login">Submit</button>                        
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        <!-- CONFIRMATION MESSAGES-->
            <app-confirmation v-if="showingMessageModal" 
                            @showDialogue="closeDialogue" 
                            :successMessage="successMessage" 
                            :errorMessage="errorMessage" />
    </div>
</template>

<script>
    import axios from 'axios'
    import { required, email } from 'vuelidate/lib/validators'
    import conDialog from '@/components/Helpers/ConfirmationDialogue.vue'

    export default {
            components: {
                    'app-confirmation' : conDialog
                },
            data() {
                    return {
                        apiURL: process.env.APP_API,
                        showingMessageModal: false,
                        errorMessage: '',
                        successMessage: '',
                        userpassword: '',
                        useremail: ''
                    }
                },
            validations: {
                    useremail: {
                        required,
                        email
                    },
                    userpassword: {
                        required
                    }
                },
            methods: {
                    closeDialogue(status){
                            this.showingMessageModal = status
                        },
                    login(){
                            var formData = new FormData()

                            formData.append('useremail', this.useremail)                
                            formData.append('userpassword', this.userpassword)

                                // for(var item of formData){
                                //      console.log('На отправку!', item)
                                //     }  

                               axios.post(this.apiURL + '?action=login', formData)
                                    .then((res) => {
                                        if(res.data.error){
                                            console.log(res.data)                                
                                            this.errorMessage = res.data.message
                                            this.showingMessageModal = true

                                        } else {
                                            console.log(res.data)  
                                            this.successMessage = res.data.message
                                            this.showingMessageModal = true

                                            var id = res.data.id
                                            var security = res.data.security

                                                localStorage.setItem('id', id)
                                                localStorage.setItem('security', security)

                                                console.log('Вернулось id: ', id)
                                                console.log('Вернулось секурити: ', security)

                                                setTimeout(()=> {
                                                    this.showingMessageModal = false
                                            }, 2000)
                                                setTimeout(()=> {
                                                    this.$router.push({name: 'Admin'})
                                            }, 3000)
                                        }
                                    })
                            this.successMessage = ''
                            this.errorMessage = ''
                        }
                }
        }
</script>

<style>
    /* MODAL MESSAGE */    
    .modalMessageContent {
        min-height: 100px;
        padding: 1px;
    }
    .modalMessageContainer {
        width: 500px;
        background: #ffffff;
        margin: auto;
        margin-top: 150px;
        border-radius: 8px;
    }
    .modalMessageHeading {
        padding: 6px;
        color: #ffffff;
    }
    .modMessageBackground {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom:0;
        background: rgba(0,0,0,0.4); z-index:99;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/Login.vue